import axios from "axios";
import { getToken } from "auth/useToken";

const axiosClient = axios.create({
  // baseURL: "http://localhost:6002",
  baseURL: "https://tktapi.estudent.uz",
});

// Add request interceptor
axiosClient.interceptors.request.use(
  async (config) => {
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

axiosClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response.status === 403) {
      localStorage.removeItem("token");
      window.location.href = "/login";
    }
    throw error;
  },
);

export default axiosClient;
